module.exports = __webpack_public_path__ + "843b19d7a54e1116b79757f7a5d5561f.svg";